import useSelectedIndex from '../../../../hooks/stateful/useSelectedIndex';
import { defaultSizeIndex } from '../../../defaultSizeIndex';
import { PREMIUM_ACCESS_TYPE } from '../types';

interface OptionWithAgreementType {
  agreementType?: string;
  sizes?: Array<{ name?: string; isDefault?: boolean }>;
}

// AssetSizes and ProjectCodes both render off useSelectedIndex().selectedOption
// (options[selectedOptionIndex]), which they read independently of BatchAgreements.
// This hook is the one place that re-points selectedOptionIndex at a freshly
// switched agreement's option, so that dependency is named and findable instead
// of being an inline side effect of the PA-switch mutation.
//
// Matches by type, not the id the switch was called with — the backend can
// resolve a different PA agreement (see DownloadService#choosePaAgreement).
const useBatchDownloadSelection = () => {
  const { selectedSize, setSelectedIndex } = useSelectedIndex();

  const selectAgreementOption = (
    freshOptions: OptionWithAgreementType[] | undefined
  ) => {
    // Assumes at most one PremiumAccess option per response; picks the first
    // if that ever changes.
    const freshIndex = freshOptions?.findIndex(
      (option) => option.agreementType === PREMIUM_ACCESS_TYPE
    );
    if (!freshOptions || freshIndex === undefined || freshIndex < 0) return;

    const freshSizes = freshOptions[freshIndex].sizes ?? [];
    const sameSizeIndex = freshSizes.findIndex(
      (size) => size.name === selectedSize?.name
    );
    setSelectedIndex(
      {
        selectedOptionIndex: freshIndex,
        selectedSizeIndex:
          sameSizeIndex > -1 ? sameSizeIndex : defaultSizeIndex(freshSizes),
      },
      freshOptions
    );
  };

  return { selectAgreementOption };
};

export default useBatchDownloadSelection;
